import { View, Text, Pressable } from 'react-native';
import Unicon from './Unicon';
import { StyleSheet } from 'react-native-unistyles';

const AdminViewingBanner = ({ message, topInset, onDismiss }) => {
    return (
        <View style={[styles.container, { paddingTop: topInset }]}>
            <View style={styles.banner}>
                <Unicon name="eye-outline" size={16} colorVariant="warning" />
                <Text style={styles.text}>{message}</Text>
                <Pressable onPress={onDismiss} style={styles.closeButton} hitSlop={8}>
                    <Unicon name="close" size={18} colorVariant="textSecondary" />
                </Pressable>
            </View>
        </View>
    );
};

export default AdminViewingBanner;

const styles = StyleSheet.create(({ colors, fonts }) => ({
    container: {
        width: '100%',
    },
    banner: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        paddingHorizontal: 16,
        paddingVertical: 10,
        backgroundColor: colors.warningSubtle,
        borderBottomWidth: 1,
        borderBottomColor: colors.borderSubtle,
        maxWidth: 700,
        width: '100%',
        alignSelf: 'center',
    },
    text: {
        flex: 1,
        fontSize: 13,
        color: colors.textSecondary,
        lineHeight: 18,
        fontFamily: fonts.body,
    },
    closeButton: {
        padding: 4,
    },
}));
